<template>
  <b-modal
    size="lg"
    ok-title="Create"
    title="Create Company"
    :visible="visible"
    @change="val => $emit('update:visible', val)"
    modal-class="create-company-modal"
    hide-footer
  >
    <template v-if="company">

      <validation-observer ref="formRef">

        <form-wizard
          ref="formWizardRef"
          color="#7367F0"
          :title="null"
          :subtitle="null"
          finish-button-text="Submit"
          back-button-text="Previous"
          class="steps-transparent mb-3"
          :start-index="company.step"
          @on-complete="saveByStep(3)"
          :nextButtonText="nextButtonText()"
        >

          <template>
            <tab-content lazy title="Company Name" :before-change="() => saveByStep(1)" >
              <step1 :company="company" :loading.sync="loading"/>
            </tab-content>

            <tab-content #default="props" title="Connect Company" :before-change="() => saveByStep(2)">
              <step2 v-if="props.active" :company="company"/>
            </tab-content>

            <tab-content #default="props" title="Company Info Approve" :before-change="() => saveByStep(3)">
              <step3 v-if="props.active" :loading.sync="loading" :company="company"/>
            </tab-content>
          </template>
        </form-wizard>

      </validation-observer>

      <b-overlay :show="loading" no-wrap/>
    </template>
  </b-modal>
</template>
<script>
import {
  BAvatar,
  BButton,
  BCol,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BModal,
  BOverlay,
  BRow,
  BTable
} from 'bootstrap-vue';
import {FormWizard, TabContent} from 'vue-form-wizard'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import VSelect from "vue-select";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import VSelectPaginated from '@core/components/v-select-paginated'

import {saveCompanyByStep} from "@/api/company";

import Step1 from './steps/1';
import Step2 from './steps/2';
import Step3 from './steps/3';

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BOverlay,
    BAvatar,
    BTable,
    BButton,

    FormWizard,
    TabContent,
    VSelect,
    ValidationProvider,
    ValidationObserver,

    VSelectPaginated,
    Step1,
    Step2,
    Step3,
  },
  props: {
    visible: Boolean,
    company: Object,
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    nextButtonText(){
      return "Next"
    },
    saveByStep(step) {
      return new Promise(async (resolve, reject) => {
        this.loading = true

        try {
          const {message, company} = await saveCompanyByStep(step, this.company)
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {title: message, icon: 'BellIcon', variant: 'success',},
          });

          if (company.is_created) {
            return this.$emit('success');
          }

          this.$set(this.company, 'id', company.id)
          this.$set(this.company, 'step', company.step)

          this.loading = false
          resolve(true)

        } catch (e) {

          this.loading = false
          this.$refs.formRef.setErrors(e.errors)

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {title: e.message, icon: 'AlertTriangleIcon', variant: 'danger',},
          })

          reject()
        }
      })
    }
  },
}
</script>
<style lang="scss">
.create-company-modal {
  .wizard-tab-content {
    box-shadow: none;
  }

  .wizard-card-footer {
    box-shadow: none;
  }

  .input-group-merge {
    .input-group-text {
      padding: 0;
    }
  }
}
</style>
